<template>
    <div class="full-form">
        <div class="form">
            <div class="close-panel">
                <div class="title">Оформление заказа</div>
                <a @click="store.stateFull()">&times;</a>
            </div>
            <div class="top">
                <div class="list">
                    <AddressList
                        :store="store"
                        :Api="Api"
                    />
                </div>
            </div>
            <div class="for-button">
                <button type="button" @click="store.addAddress()" class="add-address">Добавить адрес</button>
            </div>
            <div class="bottom">
                <Client
                        :store="store"
                        :Api="Api"
                />
            </div>
            <Map :store="store" :Api="Api"/>
            <Warning :store="store"/>
            <Sms :store="store"/>
        </div>
    </div>
</template>

<script>
import AddressList from './components/AddressList.vue';
import Map from './components/Map.vue';
import Client from './components/Client.vue';
import Warning from './components/Warning.vue';
import Sms from './components/Sms.vue';

export default {
    props: ["store", "Api"],
    components: {
        AddressList, Map, Client, Warning, Sms
    },
}
</script>
<style lang="scss">
    #yacurier-form{
        .full-form{
            align-items: center;
            background: rgba(0,0,0,.7);
            bottom: 0;
            display: flex;
            justify-content: center;
            left: 0;
            position: fixed;
            right: 0;
            top: 0;
            z-index: 101;
            .form{
                align-items: stretch;
                background: #FFF;
                border: 1px solid #f2f6fc;
                box-shadow: 0 14px 20px 0 rgba(164, 182, 206, .5);
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: calc(100% - 40px);
                overflow: auto;
                margin: 20px auto;
                width: 678px;
                @media(max-width: 768px){
                    width: calc(100% - 40px);
                }
                .close-panel{
                    align-items: center;
                    background: #FBFBFB;
                    border-bottom: 1px solid #CACFDC;
                    box-sizing: border-box;
                    display: flex;
                    flex-grow: 0;
                    flex-shrink: 1;
                    padding: 10px 25px;
                    .title{
                        color: #333;
                        font-size: 14px;
                        font-weight: 600;
                        flex-grow: 1;
                        flex-shrink: 0;
                    }
                    a{
                        color: #333;
                        cursor: pointer;
                        flex-grow: 0;
                        flex-shrink: 1;
                        font-size: 20px;
                        margin-left: 20px;
                        opacity: .4;
                        &:hover{
                            opacity: 1;
                        }
                    }
                }
                .top{
                    flex-grow: 1;
                    flex-shrink: 0;
                    position: relative;
                    .list{
                        /*bottom: 0;*/
                        /*left: 0;*/
                        overflow: auto;
                        padding: 25px;
                        /*position: absolute;*/
                        /*right: 0;*/
                        /*top: 0;*/
                    }
                }
                .for-button{
                    border-top: 1px solid #CACFDC;
                    flex-grow: 0;
                    flex-shrink: 1;
                    padding: 25px;
                }
                .bottom{
                    background: #FBFBFB;
                    border-top: 1px solid #CACFDC;
                    box-sizing: border-box;
                    flex-grow: 0;
                    flex-shrink: 1;
                    padding: 25px;
                }
            }
            input[type*="te"],
            input[type="number"],
            input[type="time"],
            textarea{
                background-color: #FFF;
                border: 1px solid #E1E1E1;
                border-radius: 0;
                box-sizing: border-box;
                font-family: 'Open Sans', sans-serif;
                font-size: 14px;
                padding: 6px 12px;
                &:focus{
                    border-color: #71B8EC;
                    + button{
                        border-color: #71B8EC;
                        font-size: 12px;
                    }
                }
                &.mx-input{
                    box-shadow: none;
                    border-radius: 0;
                }

            }

            textarea{
                resize: none;
                width: 100%;
            }
            .add-address{
                background: #FFD957;
                border: none;
                border-radius: 5px;
                color: #60605D;
                font-size: 12px;
                padding: 7px 15px;
                text-decoration: none;
                transition: all .125s ease-in;
                &:hover{
                    background: #ffd043;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/blocks/FullForm/Index.vue